/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */
import * as References from './ConnectedStatusGraphQLService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetch
 */
export const FETCH_QUERY_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetch';
export const FETCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetchAllForUser
 */
export const FETCH_ALL_FOR_USER_QUERY_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetchAllForUser';
export const FETCH_ALL_FOR_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_ALL_FOR_USER_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.fetchAllForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#dismissBatch
 */
export const DISMISS_BATCH_MUTATION_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_dismissBatch';
export const DISMISS_BATCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DISMISS_BATCH_MUTATION_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.dismissBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#dismissBatchForUser
 */
export const DISMISS_BATCH_FOR_USER_MUTATION_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_dismissBatchForUser';
export const DISMISS_BATCH_FOR_USER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DISMISS_BATCH_FOR_USER_MUTATION_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.dismissBatchForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});